import { render, staticRenderFns } from "./EditarHistoricoTempo.vue?vue&type=template&id=707538a2"
import script from "./EditarHistoricoTempo.vue?vue&type=script&lang=js"
export * from "./EditarHistoricoTempo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports